import { templateApi } from "@/core/data/api";

export default async (id) => {
  return await templateApi.removeTemplate(id);
};
